<template>
	<button
		:class="['social-icon-button', size, { 'ph-layout': isPhLayoutA }]"
		@click="emit('onClick')"
	>
		<component :is="iconComponent" :class="iconClasses" v-if="iconComponent" />

		<span class="social-icon-button__text">{{ text }}</span>
		<span class="social-icon-button__placeholder"></span>
		<span class="social-icon-button__tag" v-if="isShowTag">{{ tagText }}</span>
	</button>
</template>

<script lang="ts" setup>
import { computed, type PropType } from 'vue'
import login_apple from '@/assets/icons/login_apple.vue'
import login_google from '@/assets/icons/login_google.vue'
import login_facebook from '@/assets/icons/login_facebook.vue'

const props = defineProps({
	icon: {
		// google, facebook, apple
		type: String as PropType<'google' | 'facebook' | 'apple'>,
		default: '',
	},
	text: {
		type: String,
		default: '',
	},
	size: {
		// md, sm
		type: String,
		default: 'md',
	},
	tagText: {
		type: String,
		default: '',
	},
	isShowTag: {
		type: Boolean,
		default: false,
	},
	isPhLayoutA: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['onClick'])

const iconComponents = {
	apple: login_apple,
	google: login_google,
	facebook: login_facebook,
}

const iconComponent = computed(() => iconComponents[props.icon])

const iconClasses = computed(() => {
	if (props.size === 'md') {
		return 'w-24px h-24px'
	}
	if (props.size === 'sm') {
		return 'w-16px h-16px'
	}
	return ''
})
</script>
